export enum CartMessageCode {
  AssemblyServiceNotAvailable = 'AssemblyServiceNotAvailable',
  ItemQuantityAdjusted = 'ItemQuantityAdjusted',
  ItemMaxQuantityExceeded = 'ItemMaxQuantityExceeded',
  ItemNotSellable = 'ItemNotSellable',
  ItemSplitDelivery = 'ItemSplitDelivery',
  ItemDelayedDelivery = 'ItemDelayedDelivery',
  CartsMerged = 'CartsMerged',
  VoucherInvalid = 'VoucherInvalid',
  VoucherNotApplicable = 'VoucherNotApplicable',
  VoucherWrongAppDomain = 'VoucherWrongAppDomain',
  VoucherConsumed = 'VoucherConsumed',
  VoucherLowBalance = 'VoucherLowBalance',
  VoucherNotEnoughItems = 'VoucherNotEnoughItems',
  VoucherExpired = 'VoucherExpired',
  VoucherNotValidYet = 'VoucherNotValidYet',
  VoucherExclusivityInvalid = 'VoucherExclusivityInvalid',
  VoucherNotHomeClubMember = 'VoucherNotHomeClubMember',
  VoucherCustomerNumberMismatch = 'VoucherCustomerNumberMismatch',
  VoucherAccountTypeMismatch = 'VoucherAccountTypeMismatch',
  VoucherActivationConflictWithCoupon = 'VoucherActivationConflictWithCoupon',
  VoucherNotApplicableDueToCoupon = 'VoucherNotApplicableDueToCoupon',
  BlockedForB2BAccount = 'BlockedForB2BAccount',
  CartItemQuantityAdjusted = 'CartItemQuantityAdjusted',
  ItemPriceHasChanged = 'ItemPriceHasChanged',
  CheckoutBlockedDueToHomeClubExclusiveCoupon = 'CheckoutBlockedDueToHomeClubExclusiveCoupon',
}

export enum CustomCardMessageCode {
  MultipleCampaigns = 'MultipleCampaigns',
  VoucherNotAppliedToAllItems = 'VoucherNotAppliedToAllItems',
}

export enum CartMessageText {
  AssemblyServiceNotAvailable = 'h24_assembly_service_not_available',
  ItemQuantityAdjusted = 'h24_item_quantity_adjusted',
  ItemMaxQuantityExceeded = 'h24_item_max_quantity_exceeded',
  ItemNotSellable = 'h24_item_not_sellable',
  ItemSplitDelivery = 'h24_item_split_delivery',
  ItemDelayedDelivery = 'h24_item_delayed_delivery',
  CartsMerged = 'h24_carts_merged',
  MultipleCampaigns = 'h24_cart_has_multiple_campaigns',
  VoucherInvalid = 'h24_code_apply_error',
  VoucherNotApplicable = 'h24_voucher_not_applicable',
  VoucherWrongAppDomain = 'h24_voucher_wrong_app_domain',
  VoucherConsumed = 'h24_voucher_consumed',
  VoucherLowBalance = 'h24_voucher_low_balance',
  VoucherNotEnoughItems = 'h24_voucher_not_enough_items',
  VoucherExpired = 'h24_voucher_expired',
  VoucherNotValidYet = 'h24_voucher_not_valid_yet',
  VoucherExclusivityInvalid = 'h24_voucher_exclusivity_invalid',
  VoucherNoFirstPartyItem = 'h24_voucher_no_first_party_item',
  VoucherCustomerNumberMismatch = 'h24_voucher_customer_number_mismatch',
  VoucherNotAppliedToAllItems = 'h24_voucher_not_applied_to_all',
  VoucherActivationConflictWithCoupon = 'h24_voucher_along_coupon_not_applicable',
  VoucherNotApplicableDueToCoupon = 'h24_voucher_removed_due_to_coupon',
  BlockedForB2BAccount = 'h24_cart_b2b_blocked_message',
  CartItemQuantityAdjusted = 'h24_cart_item_quantity_adjusted',
  ItemPriceHasChanged = 'h24_item_price_has_changed',
  GiftCardsNotRedeemedMpCart = 'h24_gift_card_not_redeemed_mp_cart_message',
  GiftCardsNotRedeemedMixedCart = 'h24_gift_card_not_redeemed_mixed_cart_message',
  BadRequest = 'h24_something_went_wrong',
}

export enum CartVoucherHomeClubMessageText {
  Guest = 'h24_voucher_home_club_guest_error',
  NotLoggedIn = 'h24_voucher_home_club_not_logged_in_error',
  NotMember = 'h24_voucher_home_club_not_member_error',
}

export enum CartVoucherAccountTypeMismatchMessageText {
  NotLoggedIn = 'h24_voucher_account_type_mismatch_not_logged_in',
  LoggedIn = 'h24_voucher_account_type_mismatch_logged_in',
}
